import { storeToRefs } from 'pinia';
import {
  useContactsStore,
  useContactsGetters,
  useContactsSetters,
} from './use-contacts-store';
import { useContactsActions } from './use-contacts-actions';
export { useContactInfo } from './use-contact-info';
export { SchemaItemTrigger, SchemaItem } from './types';

export const useContacts = () => {
  return {
    ...storeToRefs(useContactsStore()),
    ...useContactsGetters(),
    ...useContactsSetters(),
    ...useContactsActions(),
  };
};
